export type ImageProps = React.ComponentProps<'img'>;

export const Image = (props: ImageProps) => {
  return (
    <figure className="relative w-fit h-auto">
      <img loading="lazy" {...props} />
    </figure>
  );
};
